import { NgModule } from '@angular/core'
import { BackButtonDirective } from '../directives/backbutton.directive'
import { SubmitButtonDirective } from '../directives/submitbutton.directive'

@NgModule({
  declarations: [ SubmitButtonDirective, BackButtonDirective ],
  imports: [],
  exports: [ SubmitButtonDirective, BackButtonDirective ],
})
export class ButtonModule {}
